/* ============================================================
   IOI LAB - Product Page Sample behaviors (dev theme only)
   - "Most Popular" badge on the 3'x5' size pill
   - Default-select 3'x5' when no variant is chosen in the URL
   - Kit selector (Flag Only vs Complete Set)
   - Delivery estimate line
   - Size guide modal
   - Sticky add-to-cart bar
   - Wholesale note next to Contact Us state
   ============================================================ */
(function () {
  'use strict';

  var POPULAR_SIZE = /^3'\s*x\s*5'$/i;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Most Popular badge + default 3x5 ---------- */
  function decoratePills() {
    var pills = document.querySelectorAll('.product-form__input--pill input[type="radio"]');
    var target = null;
    pills.forEach(function (input) {
      if (!POPULAR_SIZE.test(input.value.trim())) return;
      target = input;
      var label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      if (label) label.classList.add('ioi-mp-label');
      if (label && !label.querySelector('.ioi-mp-badge')) {
        var b = document.createElement('span');
        b.className = 'ioi-mp-badge';
        b.textContent = '\u2605 Most Popular';
        label.appendChild(b);
      }
    });
    return target;
  }

  function defaultToPopular() {
    if (new URLSearchParams(window.location.search).has('variant')) return;
    if (sessionStorage.getItem('ioiDefaulted')) return;
    // wait until Dawn's variant/product listeners are attached before clicking
    Promise.all([
      customElements.whenDefined('variant-selects'),
      customElements.whenDefined('product-info')
    ]).then(function () {
      setTimeout(function () {
        var target = decoratePills();
        if (target && !target.checked && !target.disabled) {
          sessionStorage.setItem('ioiDefaulted', '1');
          target.click();
        }
      }, 500);
    });
  }

  /* ---------- Delivery estimate ---------- */
  function businessDaysFrom(start, days) {
    var d = new Date(start);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days--;
    }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }
  function fillDeliveryEstimate() {
    var el = document.querySelector('[data-ioi-delivery]');
    if (!el) return;
    var now = new Date();
    var from = businessDaysFrom(now, 4); // ships 1-2 biz days + fast end of transit
    var to = businessDaysFrom(now, 8);
    el.innerHTML =
      'Order today and it typically arrives <strong>' + fmt(from) + ' &ndash; ' + fmt(to) + '</strong>';
  }

  /* ---------- Size guide modal ---------- */
  function sizePillFor(size) {
    var pills = document.querySelectorAll('.product-form__input--pill input[type="radio"]');
    for (var i = 0; i < pills.length; i++) {
      if (pills[i].value.trim() === size) return pills[i];
    }
    return null;
  }

  function wireSizeGuide() {
    var modal = document.getElementById('IoiSizeGuide');
    if (!modal) return;

    // fixed positioning breaks inside Dawn's transformed sticky column: move modal to <body>
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    document.querySelectorAll('[data-ioi-sg-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // mark rows whose size this product doesn't offer
        modal.querySelectorAll('tbody tr[data-ioi-size]').forEach(function (row) {
          var pill = sizePillFor(row.getAttribute('data-ioi-size'));
          row.classList.toggle('ioi-sg--unavailable', !pill || pill.disabled);
        });
        modal.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
      });
    });
    modal.querySelectorAll('[data-ioi-sg-close]').forEach(function (el) {
      el.addEventListener('click', closeSg);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSg();
    });

    // click a row to select that size variant
    modal.querySelectorAll('tbody tr[data-ioi-size]').forEach(function (row) {
      row.addEventListener('click', function () {
        var pill = sizePillFor(row.getAttribute('data-ioi-size'));
        if (!pill || pill.disabled) return;
        if (!pill.checked) pill.click();
        closeSg();
      });
    });

    function closeSg() {
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
  }

  /* ---------- Kit selector (Flag Only vs Complete Set) ---------- */
  var kitState = { mode: 'flag', bundle: null };

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function currentFlagPrice() {
    var scope = document.querySelector('.product__info-container');
    if (!scope) return '';
    var sale = scope.querySelector('.price--on-sale .price__sale .price-item--sale');
    var el = sale || scope.querySelector('.price-item--regular');
    return el ? el.textContent.trim().replace(/\s+/g, ' ').replace(/\s*USD\s*$/, '') : '';
  }

  function currentFlagCompare() {
    var scope = document.querySelector('.product__info-container');
    if (!scope) return '';
    var el = scope.querySelector('.price--on-sale .price__sale .price-item--regular');
    return el ? el.textContent.trim().replace(/\s+/g, ' ').replace(/\s*USD\s*$/, '') : '';
  }

  // IOI 2026-08-18: the AJAX product JSON has no compare_at_price when the sale
  // comes from a market/catalog price adjustment, so pull the server-rendered
  // price block for a counterpart variant via the Section Rendering API.
  var kitRendered = {};
  function kitRenderedPrice(handle, variantId) {
    var key = handle + ':' + variantId;
    if (kitRendered[key]) return Promise.resolve(kitRendered[key]);
    var info = document.querySelector('product-info');
    var sectionId = (info && info.dataset && info.dataset.section) || '';
    if (!sectionId) {
      var vsEl = document.querySelector('variant-selects[id^="variant-selects-"]');
      if (vsEl) sectionId = vsEl.id.replace('variant-selects-', '');
    }
    if (!sectionId) return Promise.resolve(null);
    return fetch('/products/' + handle + '?variant=' + variantId + '&section_id=' + sectionId)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        if (!t) return null;
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var scope = doc.querySelector('.product__info-container') || doc;
        var clean = function (el) { return el ? el.textContent.trim().replace(/\s+/g, ' ').replace(/\s*USD\s*$/, '') : ''; };
        var out = {
          sale: clean(scope.querySelector('.price__sale .price-item--sale') || scope.querySelector('.price__regular .price-item--regular')),
          compare: clean(scope.querySelector('.price--on-sale .price__sale .price-item--regular'))
        };
        kitRendered[key] = out;
        return out;
      })
      .catch(function () { return null; });
  }

  var kitProducts = {};
  function kitLoad(handle) {
    if (!handle) return Promise.resolve(null);
    if (kitProducts[handle]) return Promise.resolve(kitProducts[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { kitProducts[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function kitOptIndex(p, name) {
    for (var i = 0; i < p.options.length; i++) {
      var n = p.options[i].name || p.options[i];
      if (String(n).toLowerCase() === name.toLowerCase()) return i;
    }
    return -1;
  }

  function kitSelectedOption(name) {
    var lower = name.toLowerCase();
    var groups = document.querySelectorAll('.product__info-container fieldset');
    for (var i = 0; i < groups.length; i++) {
      var legend = groups[i].querySelector('legend');
      if (!legend) continue;
      var t = legend.textContent.trim().toLowerCase();
      if (t === lower || t.indexOf(lower) === 0) {
        var c = groups[i].querySelector('input:checked');
        if (c) return c.value;
      }
    }
    var drops = document.querySelectorAll('.product__info-container .product-form__input--dropdown');
    for (var j = 0; j < drops.length; j++) {
      var lab = drops[j].querySelector('label');
      if (lab && lab.textContent.trim().toLowerCase().indexOf(lower) === 0) {
        var s = drops[j].querySelector('select');
        if (s) return s.value;
      }
    }
    return null;
  }

  // IOI 2026-07-30c: Allegiance-style placement - selector sits above qty + ATC.
  // The theme wraps picker/qty/buttons in .variant-container, so template block
  // order can't slot the cards in between; relocate the node instead.
  function placeKit(wrap) {
    var anchor =
      document.querySelector('.variant-container .product-form__quantity') ||
      document.querySelector('.variant-container .product-form__container');
    if (anchor && wrap.nextElementSibling !== anchor) {
      anchor.parentElement.insertBefore(wrap, anchor);
    }
  }

  function wireKitCards() {
    var wrap = document.querySelector('[data-ioi-kit]');
    if (!wrap) return;
    placeKit(wrap);
    var dir = wrap.getAttribute('data-kit-dir') || 'to-set';
    var polesRow = wrap.querySelector('[data-ioi-kit-poles]');
    var pole = 'Silver';

    function altHandle() {
      if (dir === 'to-set') return wrap.getAttribute('data-counterpart-handle');
      var mat = kitSelectedOption('Flag Material') || 'Nylon';
      return /poly/i.test(mat) ? wrap.getAttribute('data-flag-poly') : wrap.getAttribute('data-flag-nylon');
    }

    function paintPoles() {
      if (!polesRow) return;
      polesRow.querySelectorAll('[data-pole]').forEach(function (b) {
        b.classList.toggle('is-selected', b.getAttribute('data-pole') === pole);
      });
    }

    function findAlt(p) {
      if (!p) return null;
      if (dir === 'to-set') {
        var size = kitSelectedOption('Size');
        var mat = wrap.getAttribute('data-kit-material');
        var oS = kitOptIndex(p, 'Flag Size'), oM = kitOptIndex(p, 'Flag Material'), oP = kitOptIndex(p, 'Pole Color');
        if (oS < 0 || !size) return null;
        var match = function (wantPole) {
          for (var i = 0; i < p.variants.length; i++) {
            var v = p.variants[i];
            if (!v.available) continue;
            if (v.options[oS] !== size) continue;
            if (oM >= 0 && mat && v.options[oM] !== mat) continue;
            if (oP >= 0 && wantPole && v.options[oP] !== wantPole) continue;
            return v;
          }
          return null;
        };
        var v = match(pole) || match(null);
        if (v && oP >= 0 && v.options[oP] !== pole) { pole = v.options[oP]; paintPoles(); }
        return v;
      }
      var size2 = kitSelectedOption('Flag Size');
      var oS2 = kitOptIndex(p, 'Size');
      if (oS2 < 0 || !size2) return null;
      for (var k = 0; k < p.variants.length; k++) {
        var v2 = p.variants[k];
        if (v2.available && v2.options[oS2] === size2) return v2;
      }
      return null;
    }

    function selectMode(mode) {
      kitState.mode = mode;
      wrap.querySelectorAll('.ioi-kit__card').forEach(function (c) {
        c.classList.toggle('is-selected', c.getAttribute('data-kit-mode') === mode);
      });
      if (polesRow) polesRow.hidden = !(dir === 'to-set' && mode === 'set');
      syncKitMode();
    }

    function refresh() {
      kitLoad(altHandle()).then(function (p) {
        var altCard = wrap.querySelector('[data-kit-mode="set"]');
        var priceEl = wrap.querySelector('[data-ioi-kit-set-price]');
        var compEl = wrap.querySelector('[data-ioi-kit-set-compare]');
        var saveEl = wrap.querySelector('[data-ioi-kit-set-save]');
        if (!p) { wrap.hidden = true; return; }
        wrap.hidden = false;
        var v = findAlt(p);
        if (!v) {
          kitState.bundle = null;
          altCard.classList.add('is-disabled');
          if (priceEl) priceEl.textContent = dir === 'to-set' ? 'Flag only in this size' : 'Unavailable';
          if (compEl) compEl.textContent = '';
          if (saveEl) saveEl.textContent = '';
          if (kitState.mode === 'set') selectMode('flag');
          syncKitMode();
          return;
        }
        altCard.classList.remove('is-disabled');
        kitState.bundle = {
          id: v.id,
          url: '/products/' + p.handle + '?variant=' + v.id,
          price: v.price,
          compare: v.compare_at_price,
          sub: dir === 'to-set' ? 'Complete Set: flag, pole, bracket & rings' : 'Flag only, no hardware'
        };
        if (priceEl) priceEl.textContent = money(v.price);
        if (compEl) compEl.textContent = (v.compare_at_price && v.compare_at_price > v.price) ? money(v.compare_at_price) : '';
        if (saveEl) saveEl.textContent = (v.compare_at_price && v.compare_at_price > v.price) ? 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%' : '';
        kitRenderedPrice(p.handle, v.id).then(function (rp) {
          if (!rp || !kitState.bundle || kitState.bundle.id !== v.id) return;
          if (rp.sale && priceEl) priceEl.textContent = rp.sale;
          if (compEl) compEl.textContent = rp.compare || compEl.textContent;
          if (saveEl && rp.compare && rp.sale) {
            var sNum = parseFloat(rp.sale.replace(/[^0-9.]/g, ''));
            var cNum = parseFloat(rp.compare.replace(/[^0-9.]/g, ''));
            if (cNum > sNum) saveEl.textContent = 'Save ' + Math.round((cNum - sNum) * 100 / cNum) + '%';
          }
          syncStickyPrice();
        });
        syncKitMode();
      });
    }

    wrap.querySelectorAll('.ioi-kit__card').forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.classList.contains('is-disabled')) return;
        // IOI 2026-08-18: the alternate card now navigates to the counterpart
        // product page (matching variant preselected) instead of rerouting the
        // add-to-cart in place. The current page’s card is a no-op.
        var mode = card.getAttribute('data-kit-mode');
        if (mode === 'set') {
          var url = kitState.bundle && kitState.bundle.url;
          if (!url) { var h = altHandle(); if (h) url = '/products/' + h; }
          if (url) window.location.href = url;
          return;
        }
        selectMode(mode);
      });
    });

    if (polesRow) polesRow.querySelectorAll('[data-pole]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        pole = b.getAttribute('data-pole');
        paintPoles();
        refresh();
      });
    });

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.product__info-container fieldset, .product-form__input--dropdown')) {
        setTimeout(refresh, 60);
      }
    });

    var flagPriceEl = wrap.querySelector('[data-ioi-kit-flag-price]');
    if (flagPriceEl) flagPriceEl.textContent = currentFlagPrice();
    var flagCompEl = wrap.querySelector('[data-ioi-kit-flag-compare]');
    if (flagCompEl) flagCompEl.textContent = currentFlagCompare();
    var flagSaveEl = wrap.querySelector('[data-ioi-kit-flag-save]');
    function syncFlagSave() {
      if (!flagSaveEl) return;
      var pr = parseFloat((currentFlagPrice() || '').replace(/[^0-9.]/g, ''));
      var cp = parseFloat((currentFlagCompare() || '').replace(/[^0-9.]/g, ''));
      var txt = (cp && pr && cp > pr) ? 'Save ' + Math.round((cp - pr) * 100 / cp) + '%' : '';
      if (flagSaveEl.textContent !== txt) flagSaveEl.textContent = txt;
    }
    syncFlagSave();

    var syncScheduled = false;
    var observer = new MutationObserver(function () {
      if (syncScheduled) return;
      syncScheduled = true;
      setTimeout(function () {
        syncScheduled = false;
        if (!document.body.contains(wrap)) placeKit(wrap); // re-attach if a variant re-render dropped it
        var el = wrap.querySelector('[data-ioi-kit-flag-price]');
        var pr = currentFlagPrice();
        if (el && pr && el.textContent !== pr) el.textContent = pr;
        var celC = wrap.querySelector('[data-ioi-kit-flag-compare]');
        if (celC) { var cpr = currentFlagCompare(); if (celC.textContent !== cpr) celC.textContent = cpr; }
        syncFlagSave();
        syncStickyPrice();
      }, 60);
    });
    var info = document.querySelector('.product__info-container');
    if (info) observer.observe(info, { childList: true, subtree: true });

    refresh();
  }

  function syncKitMode() {
    // IOI 2026-07-30b: theme ATC button stays visible in place with its normal
    // label; when Complete Set is selected the submit is rerouted in wireKitAtc.
    syncStickyPrice();
  }

  function kitAddAlt(qty, onDone) {
    if (!kitState.bundle) { if (onDone) onDone(false); return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: kitState.bundle.id, quantity: qty || 1, properties: { _source: 'pdp-kit-card' } }],
        sections: 'cart-drawer,cart-icon-bubble'
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (onDone) onDone(true);
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.renderContents === 'function' && res.sections) d.renderContents(res);
        else window.location.href = '/cart';
      })
      .catch(function () { if (onDone) onDone(false); });
  }

  function wireKitAtc() {
    // Capture phase on document runs before Dawn's product-form submit handler,
    // so when the alt card (Complete Set / Flag Only) is selected we swallow the
    // native submit and add the alt product's variant instead. Button never
    // moves and its label never changes.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      var action = (form && form.getAttribute('action')) || '';
      if (action.indexOf('/cart/add') === -1) return;
      if (kitState.mode !== 'set' || !kitState.bundle) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var qtyInput = form.elements ? form.elements['quantity'] : null;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.setAttribute('aria-busy', 'true');
      kitAddAlt(qty, function () {
        if (submit) submit.removeAttribute('aria-busy');
      });
    }, true);
  }

  /* ---------- Sticky ATC bar ---------- */
  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }
  function syncStickyPrice() {
    var bar = document.getElementById('IoiStickyAtc');
    if (!bar) return;
    var priceEl = bar.querySelector('[data-ioi-sticky-price]');
    var subEl = bar.querySelector('[data-ioi-sticky-sub]');
    if (kitState.mode === 'set' && kitState.bundle) {
      setText(priceEl, money(kitState.bundle.price));
      setText(subEl, (kitState.bundle && kitState.bundle.sub) || '');
    } else {
      setText(priceEl, currentFlagPrice());
      var checked = document.querySelector('.product-form__input--pill input[type="radio"]:checked');
      if (checked) setText(subEl, 'Size: ' + checked.value);
    }
  }

  function wireSticky() {
    var bar = document.getElementById('IoiStickyAtc');
    // observe a container that is never replaced by variant re-renders
    var buyBox =
      document.querySelector('.product-form__container') ||
      document.querySelector('.variant-container') ||
      document.querySelector('.product-form__buttons');
    if (!bar || !buyBox) return;

    // fixed positioning breaks inside Dawn's transformed sticky column: move bar to <body>
    if (bar.parentElement !== document.body) document.body.appendChild(bar);

    // scroll listener (not IntersectionObserver) so it also works in throttled tabs
    var ticking = false;
    function updateBar() {
      ticking = false;
      var r = buyBox.getBoundingClientRect();
      var ioiBarVisible = r.bottom < 0;
      bar.classList.toggle('is-visible', ioiBarVisible);
      // IOI 2026-07-30: let CSS alternate the Klaviyo teaser with the bar
      document.documentElement.classList.toggle('ioi-atc-open', ioiBarVisible);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      setTimeout(updateBar, 80);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateBar();

    bar.querySelector('[data-ioi-sticky-btn]').addEventListener('click', function () {
      if (kitState.mode === 'set' && kitState.bundle) {
        var stickySelf = this;
        kitAddAlt(1, function (ok) {
          if (!ok) return;
          stickySelf.textContent = 'Added \u2713';
          setTimeout(function () { stickySelf.textContent = 'Add to Cart'; }, 2500);
        });
        return;
      }
      var submit = document.querySelector('.product-form__submit');
      var contact = document.querySelector('.product-form__buttons a[href="/pages/contact"]');
      if (submit && !submit.disabled) {
        submit.click();
        var self = this;
        self.textContent = 'Added \u2713';
        setTimeout(function () { self.textContent = 'Add to Cart'; }, 2500);
      } else if (contact) {
        window.location.href = contact.getAttribute('href');
      } else {
        buyBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    syncStickyPrice();
  }

  /* ---------- Wholesale note when Contact Us shows ---------- */
  function wireWholesaleNote() {
    function apply() {
      var contact = document.querySelector('.product-form__buttons a[href="/pages/contact"]');
      var form = document.querySelector('.product-form__container');
      if (!form) return;
      var existing = form.querySelector('.ioi-b2b-note');
      if (contact && !existing) {
        var note = document.createElement('div');
        note.className = 'ioi-b2b-note';
        note.innerHTML =
          '<strong>This size is stocked for wholesale &amp; bulk orders.</strong> ' +
          'Contact us and we\u2019ll take care of you directly, or choose another size to order online right now.';
        contact.parentElement.insertBefore(note, contact);
      } else if (!contact && existing) {
        existing.remove();
      }
    }
    apply();
    var info = document.querySelector('.product__info-container');
    if (info) new MutationObserver(apply).observe(info, { childList: true, subtree: true });
  }

  ready(function () {
    decoratePills();
    defaultToPopular();
    fillDeliveryEstimate();
    wireSizeGuide();
    wireKitCards();
    wireKitAtc();
    wireSticky();
    wireWholesaleNote();

    // re-decorate after Dawn re-renders variant picker (rAF-debounced)
    var info = document.querySelector('.product__info-container');
    if (info) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          decoratePills();
        });
      }).observe(info, { childList: true, subtree: true });
    }
  });
})();
